import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-python",
  "use": "icon-python-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-python\"><path d=\"M219.429 146.286v731.429c0 40 32 72 72 72h441.142c40 0 72-32 72-72V146.286c0-40-32-72-72-72H291.429c-40 0-72 32-72 72z\" fill=\"#387CB4\" p-id=\"8426\" /><path d=\"M365.714 292.571h292.571v73.143H365.714zM365.714 438.857h219.429v73.143H365.714zM365.714 585.143h146.286v73.143H365.714z\" fill=\"#FFFFFF\" p-id=\"8427\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol